import StorageKeys from '../constants/storageKeys';

const removeBetaFeatures = () => {
  localStorage.removeItem(StorageKeys.BETA_FEATURES);
}

export {
  removeBetaFeatures
}